module.exports = __webpack_public_path__ + "img/chris (12).97538f6b.jpg";